"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailComponent = void 0;
var OrderDetail_1 = require("./OrderDetail");
Object.defineProperty(exports, "OrderDetailComponent", { enumerable: true, get: function () { return OrderDetail_1.OrderDetailComponent; } });
